import { render, staticRenderFns } from "./StartTemperaturesReport.vue?vue&type=template&id=622991f8&"
import script from "./StartTemperaturesReport.vue?vue&type=script&lang=js&"
export * from "./StartTemperaturesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports